import { credentialPolicies as policies } from 'helpers';
import Schema from './schema';


export default class Credential extends Schema {

  constructor(values) {
    super(policies, values);

    this.setDtoDefinition({
      selectProyectoURL: '',
      name: '',
      description: '',
      fromEdit: false,
      txtCred: '',
      project_id: 0
    });
  }

  setValues(data) {
    this.values = this.dtoDefinition;
    this.setDefaultValues(data);
  }
}
